import React from 'react';
import { Car, Zap, BarChart as ChartBar, ArrowRight, Check } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const EVPlan: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-wenergie-blue/10 via-sky-50 to-wenergie-orange/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Nobody buys an EV just to charge it with coal.
            </h1>
            <p className="text-xl text-gray-700 mb-8">
              Charge clean. Track everything. Earn as you go.
            </p>
            <a 
              href="#contact" 
              className="inline-flex items-center justify-center px-8 py-3 bg-wenergie-blue text-white rounded-full font-medium hover:bg-wenergie-blue/90 transition duration-300 shadow-lg"
            >
              Get Started
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            🔋 Drive Clean, Charge Smart with Wenergie
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <Car className="h-12 w-12 text-wenergie-blue mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Join the Clean Energy Network</h3>
              <p className="text-gray-600">
                Tap into Wenergie's network and charge your EV when clean energy is abundant — typically when the sun is shining.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <Zap className="h-12 w-12 text-wenergie-orange mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">Earn Rewards Automatically</h3>
              <p className="text-gray-600">
                Every clean kWh you use to charge gets you closer to real-world rewards.
              </p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-8 mb-16">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Track EV + Home Usage</h3>
            <p className="text-gray-600 mb-4">
              See exactly how much energy your EV and your home consume — all in one place.
            </p>
            <div className="flex items-center text-wenergie-blue">
              <ChartBar className="h-6 w-6 mr-2" />
              <span>Real-time consumption tracking</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Set Up in 3 Simple Steps</h3>
              <ol className="space-y-4">
                <li className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-wenergie-blue text-white flex items-center justify-center mr-3">1</span>
                  <span>Buy a ReDER Personal Energy Assistant</span>
                </li>
                <li className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-wenergie-blue text-white flex items-center justify-center mr-3">2</span>
                  <span>Download the Wenergie App</span>
                </li>
                <li className="flex items-center">
                  <span className="w-8 h-8 rounded-full bg-wenergie-blue text-white flex items-center justify-center mr-3">3</span>
                  <span>Pair and connect — in under a minute</span>
                </li>
              </ol>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Start Earning Right Away</h3>
              <p className="text-gray-600 mb-6">
                Charge when it's sunniest and watch the rewards roll in.
              </p>
              <div className="flex items-center text-wenergie-blue">
                <Check className="h-5 w-5 mr-2" />
                <span>Immediate rewards program enrollment</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default EVPlan;